document.addEventListener('keydown', function (event) {
  const control = event.target.closest('[data-sb-keyboard]');
  if (control && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault();
    control.click();
  }
});

// The legacy AJAX cart handles clicks before native form validation runs.
function sbValidateRingSize(event) {
  const form = event.type === 'submit' ? event.target : event.target.closest('button[type="submit"], .product-form__cart-submit')?.closest('form');
  const size = form?.querySelector('[data-sb-ring-size]');
  if (size && !size.checkValidity()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    size.focus();
    size.reportValidity();
  }
}
document.addEventListener('click', sbValidateRingSize, true);
document.addEventListener('submit', sbValidateRingSize, true);
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-sb-filter-toggle]');
  if (toggle) {
    // Read the state after the theme's delegated collapse handler runs.
    requestAnimationFrame(function () {
      toggle.setAttribute('aria-expanded', String(toggle.parentElement.classList.contains('act')));
    });
  }
});


// Keep keyboard focus inside the open cart and restore it on close.
document.addEventListener('DOMContentLoaded', () => {
  const cart = document.querySelector('#desktop_cart');
  if (!cart) return;
  let returnFocus = null;
  let wasOpen = false;
  const sync = () => {
    const open = cart.classList.contains('active');
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      returnFocus = document.activeElement;
      cart.setAttribute('role', 'dialog');
      cart.setAttribute('aria-modal', 'true');
      cart.setAttribute('aria-label', 'Shopping cart');
      setTimeout(() => { if (cart.classList.contains('active')) cart.querySelector('.close_cart')?.focus(); }, 350);
    } else {
      cart.removeAttribute('aria-modal');
      if (returnFocus?.isConnected) returnFocus.focus();
    }
  };
  new MutationObserver(sync).observe(cart, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('keydown', event => {
    if (!cart.classList.contains('active')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      cart.querySelector('.close_cart')?.click();
    }
    if (event.key === 'Tab') {
      const controls = Array.from(cart.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !cart.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !cart.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });
});

function sbLabelIcons() {
  document.querySelectorAll('i[class*="zmdi"], i[class*="rbb-icon"]').forEach(icon => icon.setAttribute('aria-hidden', 'true'));
  document.querySelectorAll('a.mm-next').forEach(link => {
    const name = link.parentElement.querySelector('a:not(.mm-next)')?.textContent.trim();
    link.setAttribute('aria-label', name ? 'Open ' + name + ' submenu' : 'Open submenu');
  });
  document.querySelectorAll('a.mm-prev').forEach(link => link.setAttribute('aria-label', 'Back to previous menu'));
  document.querySelectorAll('.filter_button').forEach(button => button.setAttribute('aria-label', 'Filter products'));
}
document.addEventListener('DOMContentLoaded', sbLabelIcons);
window.addEventListener('load', sbLabelIcons);

// The slide-out navigation must be absent from keyboard and screen-reader
// navigation when closed, and return focus to its opener when dismissed.
document.addEventListener('DOMContentLoaded', () => {
  const menu = document.getElementById('mobile_menu');
  if (!menu) return;
  const toggles = document.querySelectorAll('#show-megamenu, .site-nav--btn');
  let wasOpen = false;
  let opener = null;
  toggles.forEach(toggle => {
    toggle.setAttribute('aria-controls', 'mobile_menu');
    toggle.addEventListener('click', () => { if (!wasOpen) opener = toggle; });
  });
  const controls = () => Array.from(menu.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(el => {
    const rect = el.getBoundingClientRect();
    const bounds = menu.getBoundingClientRect();
    return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && rect.left >= bounds.left - 1 && rect.right <= bounds.right + 1;
  });
  const sync = () => {
    const open = menu.classList.contains('act');
    menu.inert = !open;
    menu.setAttribute('aria-hidden', String(!open));
    toggles.forEach(toggle => toggle.setAttribute('aria-expanded', String(open)));
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      menu.setAttribute('role', 'dialog');
      menu.setAttribute('aria-modal', 'true');
      menu.setAttribute('aria-label', 'Navigation');
      const focusMenu = () => { if (menu.classList.contains('act')) controls()[0]?.focus(); };
      menu.addEventListener('transitionend', focusMenu, { once: true });
      setTimeout(focusMenu, 350);
    } else {
      menu.removeAttribute('aria-modal');
      if (opener?.isConnected) opener.focus();
    }
  };
  sync();
  new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('keydown', event => {
    if (!wasOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      const activeToggle = Array.from(toggles).find(toggle => toggle.classList.contains('act'));
      activeToggle?.click();
    }
    if (event.key !== 'Tab') return;
    const items = controls(), first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) {
      event.preventDefault(); last?.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) {
      event.preventDefault(); first?.focus();
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('#sb-filter-sidebar');
  const toggle = document.querySelector('[data-toggle="FilterSidebar"]');
  const close = panel?.querySelector('[data-close="FilterSidebar"]');
  if (!panel || !toggle || !close) return;
  let wasOpen = false;
  const sync = () => {
    const open = panel.classList.contains('act');
    toggle.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
    panel.setAttribute('aria-hidden', String(!open));
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Filter products');
    if (open) panel.setAttribute('aria-modal', 'true');
    else panel.removeAttribute('aria-modal');
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      const focusClose = () => { if (panel.classList.contains('act')) close.focus(); };
      panel.addEventListener('transitionend', focusClose, {once: true});
      setTimeout(focusClose, 700);
    }
    else toggle.focus();
  };
  sync();
  new MutationObserver(sync).observe(panel, {attributes: true, attributeFilter: ['class']});
  document.addEventListener('keydown', event => {
    if (!panel.classList.contains('act')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close.click();
    }
    if (event.key !== 'Tab') return;
    const controls = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let popup = null;
  let returnFocus = null;
  const syncPopup = () => {
    const next = document.querySelector('.nov-wrap:has(.cart__popup)');
    if (next === popup) return;
    if (!next) {
      popup = null;
      if (returnFocus?.isConnected) returnFocus.focus();
      return;
    }
    popup = next;
    returnFocus = document.activeElement;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    const heading = popup.querySelector('.cart-popup-heading');
    if (heading) {
      heading.id = 'sb-cart-popup-title';
      popup.setAttribute('aria-labelledby', heading.id);
    }
    const close = popup.querySelector('.nov-close');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('data-sb-keyboard', '');
      close.setAttribute('aria-label', document.querySelector('.close_cart')?.getAttribute('aria-label') || 'Close');
      setTimeout(() => { if (popup === next) close.focus(); }, 700);
    }
  };
  new MutationObserver(syncPopup).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('keydown', event => {
    if (!popup) return;
    if (event.key === 'Escape') { event.preventDefault(); popup.querySelector('.nov-close')?.click(); }
    if (event.key !== 'Tab') return;
    const controls = Array.from(popup.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !popup.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !popup.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  });
});
document.addEventListener('change', event => {
  if (event.target.matches('.popup__cart-checkout input[name="cartcheckout"]')) {
    event.target.closest('.popup__cart-checkout').querySelector('.checkout-button')?.setAttribute('aria-disabled', String(!event.target.checked));
  }
});
document.addEventListener('click', event => {
  const checkout = event.target.closest('.popup__cart-checkout .checkout-button');
  const agreement = checkout?.closest('.popup__cart-checkout').querySelector('input[name="cartcheckout"]');
  if (agreement && !agreement.checked) {
    event.preventDefault();
    event.stopImmediatePropagation();
    agreement.focus();
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-header__cart[aria-label]').forEach(cart => {
    const label = cart.getAttribute('aria-label');
    const update = () => {
      const count = cart.querySelector('.CartCount')?.textContent.trim();
      cart.setAttribute('aria-label', count ? label + ' (' + count + ')' : label);
    };
    update();
    new MutationObserver(update).observe(cart, {childList: true, characterData: true, subtree: true});
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const cart = document.getElementById('desktop_cart');
  if (!cart) return;
  const labels = window.theme?.strings || {};
  const labelControl = (control, label) => {
    if (!control) return;
    if (!control.matches('button, input')) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('data-sb-keyboard', '');
    }
    if (label) control.setAttribute('aria-label', label);
  };
  const updateExpanded = () => {
    const panels = Array.from(cart.querySelectorAll('.cart_extend[data-content]'));
    cart.querySelectorAll('.extend--label__item[data-label]').forEach(control => {
      const panel = panels.find(item => item.dataset.content === control.dataset.label);
      control.setAttribute('aria-expanded', String(Boolean(panel?.classList.contains('act'))));
    });
  };
  const update = () => {
    cart.querySelectorAll('#cart-info .ajaxcart__product').forEach(row => {
      const title = row.querySelector('.product-name .title')?.textContent.trim() || '';
      const namedLabel = label => label?.replace('__SB_CART_TITLE__', () => title);
      labelControl(row.querySelector('.remove-from-cart'), namedLabel(labels.cart_remove_item));
      labelControl(row.querySelector('.cart__mini-qty--minus'), labels.cart_decrease_quantity);
      labelControl(row.querySelector('.cart__mini-qty--plus'), labels.cart_increase_quantity);
      const quantity = row.querySelector('.cart__mini-qty--input');
      const quantityLabel = namedLabel(labels.cart_quantity_for);
      if (quantity && quantityLabel) quantity.setAttribute('aria-label', quantityLabel);
      row.querySelectorAll('.remove-from-cart i').forEach(icon => icon.setAttribute('aria-hidden', 'true'));
    });
    const extensionLabels = {
      note: labels.cart_note_label,
      'estimate-shipping': labels.cart_shipping_label,
      discount: labels.cart_discount_label
    };
    cart.querySelectorAll('.extend--label__item[data-label]').forEach(control => {
      labelControl(control, extensionLabels[control.dataset.label] || control.getAttribute('data-title') || control.getAttribute('title') || control.textContent.trim());
    });
    cart.querySelectorAll('.cart_extend--btn').forEach(control => labelControl(control, control.textContent.trim()));
    updateExpanded();
  };
  update();
  new MutationObserver(update).observe(cart, {childList: true, subtree: true});
  document.addEventListener('click', event => {
    if (event.target.closest('.extend--label__item, .cart_extend--btn, .close_cart, .sidebar-overlay')) queueMicrotask(updateExpanded);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-nav > li').forEach((item, index) => {
    const trigger = item.querySelector(':scope > a.site-nav__link--main');
    const panel = item.querySelector(':scope > .nav-dropdown--lv1');
    if (!trigger || !panel || item.closest('#mobile_menu') || item.closest('.site-nav-mobile')) return;
    panel.id = 'sb-navigation-panel-' + index;
    trigger.setAttribute('aria-controls', panel.id);
    let hovered = false;
    let dismissed = false;
    const sync = () => {
      const open = !dismissed && (hovered || item.contains(document.activeElement));
      item.classList.toggle('sb-nav-open', open);
      item.classList.toggle('sb-nav-dismissed', dismissed);
      trigger.setAttribute('aria-expanded', String(open));
      panel.inert = !open;
    };
    item.addEventListener('mouseenter', () => { hovered = true; dismissed = false; sync(); });
    item.addEventListener('mouseleave', () => { hovered = false; sync(); });
    item.addEventListener('focusin', sync);
    item.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!item.contains(document.activeElement)) dismissed = false;
      sync();
    }));
    item.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        dismissed = true;
        trigger.focus();
        sync();
      } else if (event.target === trigger && (event.key === ' ' || event.key === 'ArrowDown')) {
        event.preventDefault();
        dismissed = false;
        sync();
        if (event.key === 'ArrowDown') Array.from(panel.querySelectorAll('a[href], button')).find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden')?.focus();
      } else if (event.target === trigger && event.key === 'Enter' && dismissed) {
        event.preventDefault();
        dismissed = false;
        sync();
      }
    });
    sync();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(input => {
    if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby') && !input.labels?.length) input.setAttribute('aria-label', input.getAttribute('placeholder'));
  });
});


// Keep header badges hidden at zero, including AJAX updates and sticky clones.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-header, #header-sticky').forEach(header => {
    const syncCounts = () => {
      header.querySelectorAll('.WishlistCount, .site-header__cart-count, .cart-count').forEach(badge => {
        badge.classList.toggle('sb-count-empty', Number(badge.textContent.trim()) === 0);
      });
    };
    syncCounts();
    new MutationObserver(syncCounts).observe(header, {childList: true, characterData: true, subtree: true});
  });
});
